<dx-popup
    #issueRefundBox
    width="35%"
    height="55%"
    title="Issue Refund"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onHidden)="onHidden($event)"
>
    <div *dxTemplate="let item of 'content'" class="ar-issue-refund-editor-content">
        <dx-box width="100%" height="100%" direction="col" *ngIf="!!issueRefundEditorData">
            <dxi-item [ratio]="1">
                <dx-form
                    #issueRefundEditorForm
                    width="100%"
                    height="100%"
                    [colCount]="1"
                    [showValidationSummary]="true"
                    [labelLocation]="defaultLabelLocation"
                    validationGroup="issueRefundFormData"
                >
                    <dxi-item>
                        <dxo-label text="Owner"></dxo-label>
                        <div *dxTemplate>
                            {{ issueRefundEditorData.owner }}
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Print As"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box [(value)]="issueRefundInfo.ownerPrintAs"></dx-text-box>
                        </div>
                    </dxi-item>

                    <dxi-item isRequired="true">
                        <dxo-label text="Document Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                [width]="100"
                                [(value)]="issueRefundInfo.documentDate"
                                type="date"
                            ></dx-date-box>
                        </div>
                    </dxi-item>

                    <dxi-item isRequired="true">
                        <dxo-label text="Post Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                [width]="100"
                                [min]="issueRefundEditorData.minPostDate"
                                [(value)]="issueRefundInfo.postDate"
                                type="date"
                            ></dx-date-box>
                        </div>
                    </dxi-item>
                    <dxi-item isRequired="true">
                        <dxo-label text="Amount"></dxo-label>
                        <div *dxTemplate>
                            <dx-number-box [(value)]="issueRefundInfo.amount" [format]="currencyFormat"></dx-number-box>
                        </div>
                    </dxi-item>
                    <dxi-item isRequired="true">
                        <dxo-label text="Description"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-area
                                [height]="70"
                                [maxLength]="170"
                                [(value)]="issueRefundInfo.description"
                            ></dx-text-area>
                        </div>
                    </dxi-item>

                    <dxi-item isRequired="true">
                        <dxo-label text="Sub Ledger"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                [searchEnabled]="true"
                                [dataSource]="issueRefundEditorData?.subLedgers"
                                displayExpr="displayText"
                                valueExpr="key"
                                [(value)]="issueRefundInfo.subLedgerId"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Cancel"
                                [icon]="closeIcon"
                                (onClick)="onHidden($event)"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Save"
                                useSubmitBehavior="true"
                                [icon]="saveIcon"
                                (onClick)="onSaveClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#issueRefundBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
